export default __webpack_public_path__ + "static/media/people_star.781d206e.svg";